import { PerspectiveGroupingRule } from '@ardoq/perspectives';
import { GroupLabel } from './GroupingRules/SharedGroupRuleElements';
import { GroupType } from '@ardoq/api-types';

type GroupingRuleLabelProps = {
  groupType: PerspectiveGroupingRule['type'];
  isDisabled?: boolean;
};

const labelMap: {
  [K in PerspectiveGroupingRule['type']]: string;
} = {
  [GroupType.COMPONENT]: 'Component Types',
  [GroupType.WORKSPACE]: 'Workspace',
  [GroupType.REFERENCE]: 'Reference',
  [GroupType.REFERENCE_TYPE_NAME]: 'Reference Type Name',
  [GroupType.TAG]: 'Tag',
  [GroupType.CHILD]: 'Child',
  [GroupType.FIELD]: 'Field',
  [GroupType.PARENT]: 'Parent',
  [GroupType.PARENT_ALL]: 'Parent all',
};

export const GroupingRuleLabel = ({
  groupType,
  isDisabled,
}: GroupingRuleLabelProps) => {
  return (
    <GroupLabel
      $isDisabled={isDisabled}
      data-testid={`group-by-${groupType}-label`}
    >
      {labelMap[groupType]}
    </GroupLabel>
  );
};
